import * as React from "react";
import { DocShape } from "@eave/shared/types/api";
import { createConditionToDocumentLink, deleteConditionToDocumentLink } from "./APIHelpers";

const FontAwesome = require("react-fontawesome");
const styles = require("./styles.module.scss");

export default ({ condition, document, onUpdate }) => {
  const isLinked =
    condition.documents &&
    condition.documents.findIndex((d: DocShape) => d.id === document.id) !== -1;
  return (
    <FontAwesome
      className={styles.pointer}
      name={isLinked ? "chain-broken" : "chain"}
      title={isLinked ? "Unlink" : "Link"}
      onClick={() => {
        if (isLinked) {
          deleteConditionToDocumentLink(condition.id, document.id).then(onUpdate);
        } else {
          createConditionToDocumentLink(condition.id, document.id).then(onUpdate);
        }
      }}
    />
  );
};
